import Settings from '../components/settings/Settings'

export default [
  { name: 'Settings', path: '/settings', components: { default: Settings}, meta: { navHidden: true, requiresAuth: true } },
]
